// removed by extract-text-webpack-plugin
module.exports = {"fixed":"fixed","content-container":"content-container","wrapper":"wrapper","note":"note","req":"req","screen-reader-text":"screen-reader-text"};


//////////////////
// WEBPACK FOOTER
// ./resources/css/scss/3-base/_global.scss
// module id = 8
// module chunks = 0